import {
    RefillModal
} from 'one-state-prescriptionrefills/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Epic User Id Component
 * @param response has the backend
 * Epic User Id  component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        agentiddata:[],
        error:undefined
    }

    const { log } = context;
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }
     
    if (response?.output?.results?.length > 0) {
        let agentinfo:RefillModal[] =[];
        let info = {
            status:"",
            refillvalue: "",
            success: false
        }
        if(response?.output?.params?.prescriptionId) {
            info.refillvalue = response?.output?.params?.prescriptionId;
            info.status = response?.status;
            info.success = response?.output?.success;
        }
        agentinfo.push(info)
        result.agentiddata=agentinfo;
    }
    log.debug(
        "ccw-gadget,Update-epic",
        "Update-epic transformation response ", {
        result
    });
    return result;
}